import React from "react";
import { Layout } from '@kursk/components/Layout/Layout';
import styles from './FAQPage.module.scss';
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { faqSlice } from "@common/redux/slices/faq.slice";
import { QuestionsAndAnswers } from "@kursk/components/pages/FAQPage/QuestionsAndAnswers";
import { map as _map } from "lodash";
import { WriteToUsForm } from "@kursk/components/ui/WriteToUsForm/WriteToUsForm";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { IFAQ } from "@common/redux/types/faqs";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";

export const FAQPage = () => {
  const { faqs } = useSelectSlice(faqSlice);
  const renderQuestionsAndAnswers = _map(faqs, (faq: IFAQ) => (<QuestionsAndAnswers key={faq._id} faq={faq}/>));

  return (
    <Layout>
      <SeoMetaTitles page="faq"/>
      <div className={styles.faq}>
        <div className={styles.faq_title}>
          Часто задаваемые вопросы
        </div>
        <div className={styles.faq_questionsListWrapper}>
          {renderQuestionsAndAnswers}
        </div>
        <div className={styles.faq_writeToUs}>
          <WriteToUsForm/>
        </div>
        <div className={styles.faq_socials}>
          <Socials/>
        </div>
      </div>
    </Layout>
  )
}
